<!-- AlertModal.vue -->
<template>
  <b-modal
    v-model="showModal"
    size="md"
    hide-footer
    centered
    header-class="ApplicationEditModalHeaderVariant"
    header-text-variant="white"
    :no-close-on-backdrop="true"
    @shown="setApplicationEditInfo(selectApplication)"
    :title="setHeaderTitle(clickType)"
    v-bind="setClearInfo()"
  >
  <!--承認済の時は編集できない-->
    <template v-slot:default>
      <div :class="{'text-black' : 'isOnlyView()'}">
        <div>
          <div class="d-flex">
            <div class="w-100">
              <!-- 作業者 -->
              <div class="WorkM_InputGroupArea"  v-if="isOnlyview()">
                <div class="d-flex">
                  <div class="WorkM_InputGroup_ItemLabel">作業者</div>
                </div>
                <div>
                  <b-input disabled :value="shainName"></b-input>
                </div>
              </div>
              <!-- 日付 -->
              <div class="WorkM_InputGroupArea">
                <div class="d-flex">
                  <div v-if="isOnlyview()" class="WorkM_InputGroup_ItemLabel mt-3">日付</div>
                  <div v-else class="WorkM_InputGroup_ItemLabel">日付</div>
                </div>
                <div>
                  <b-form-datepicker
                  v-model="rewriteApplicationDate"
                  @input="changeDate"
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    weekday: 'short'
                  }"
                  size="sm"
                  placeholder="YYYY/MM/DD"
                  :state="isDateState"
                  aria-describedby="input-live-feedback"
                  :disabled="isApproved() || isOnlyview()"
                  ></b-form-datepicker>
                  <b-form-invalid-feedback id="input-live-feedback">
                     {{ dateStateMessage }}
                  </b-form-invalid-feedback>
                </div>
                <div class="d-flex flex-row-reverse" style="height:27px;">
                  <div v-if="!emptyCheck(rewriteApplicationDateType)" style="font-size: 0.9rem; padding-top:0.15rem;">
                    {{ "（" + rewriteApplicationDateType + "）" }}
                  </div>
                </div>
              </div>
              <!-- 区分 -->
              <div class="WorkM_InputGroupArea">
                <div v-if="isOnlyview()" class="WorkM_InputGroup_ItemLabel">区分</div>
                <div v-else class="WorkM_InputGroup_ItemLabel mt-3">区分</div>
                <div>
                  <b-select size="sm"
                  :state="isSegmentState"
                  aria-describedby="input-kbn-live-feedback"
                  :options="optionsWorkSegment"
                  v-model="rewriteApplicationKbn"
                  @change="selectSegmentRest"
                  :disabled="isApproved() || isOnlyview()"></b-select>

                  <b-form-invalid-feedback id="input-kbn-live-feedback">
                     {{ messageSegmentState }}
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
            <div class="WorkM_ApplicationEditSummaryArea ml-3 border rounded-sm" style="min-width:120px;">
              <div class="WorkM_InputGroup_ItemLabel">有休残</div>
              <div class="ml-1" style="font-size: 0.9rem">
                {{ applicationRemainInfo.remainPaidHolidayDays }} ({{ applicationRemainInfo.paidLeaveYealyDays }})
              </div>
              <div class="WorkM_InputGroup_ItemLabel mt-1">振休残</div>
              <div class="ml-1" style="font-size: 0.9rem">
                {{ applicationRemainInfo.remainSubstituteHolidayTime }} ({{ applicationRemainInfo.remainSubstituteHolidayDays }})
              </div>
              <div class="WorkM_InputGroup_ItemLabel mt-1">残業</div>
              <div class="ml-1" style="font-size: 0.9rem">
                {{ applicationRemainInfo.overtimeWorkTime }} ({{ applicationRemainInfo.overtimeMonthlyMaxHours }})
              </div>
            </div>
          </div>

          <!-- 振出選択 -->
          <div class="WorkM_InputGroupArea mt-3 d-flex">
            <b-button variant="transparent"
            size="sm"
            class="WorkM_ButtonTempSuccess form-control-sm"
            :class="{'WorkEditModal_ButtonSearch': !setKbnHolidayCheck || isOnlyview()}"
            :disabled="!setKbnHolidayCheck || isOnlyview()"
            style="min-width:85px;"
            @click="btnSelectSubstituteWork()">
              振出選択
            </b-button>
            <b-input
            type="number"
            size="sm"
            :placeholder=rewriteSubstituteWork
            v-model="rewriteSubstituteWork"
            :disabled=true
            >
            </b-input>
          </div>

          <!-- 時間 -->
          <b-form-group id="input-time-live-feedback" :invalid-feedback="messageHourState" :state="isHourState">
            <div class="d-flex mt-3 WorkM_InputTime_ApplicationEditModal">
              <div class="WorkM_InputGroupArea">
                <div class="WorkM_InputGroup_ItemLabel">時間 from</div>
                <div class="WorkM_InputTimeGroup">
                  <div class="WorkM_InputTimeGroup_InputItem">
                    <b-select size="sm" aria-describedby="input-time-live-feedback" :options="optionTimeHour" v-model="rewriteStartHour" @change="timeState" :disabled="isApproved() || isOnlyview()"></b-select>
                  </div>
                  <div class="mx-1">:</div>
                  <div class="WorkM_InputTimeGroup_InputItem">
                    <b-select size="sm" aria-describedby="input-time-live-feedback" :options="setOptionStartTimeMin" v-model="rewriteStartMin" @change="timeState" :disabled="isApproved() || isOnlyview()"></b-select>
                  </div>
                </div>
              </div>

              <div class="WorkM_InputGroupArea ml-3">
                <div class="WorkM_InputGroup_ItemLabel">時間 to</div>
                <div class="WorkM_InputTimeGroup">
                  <div class="WorkM_InputTimeGroup_InputItem">
                    <b-select size="sm" aria-describedby="input-time-live-feedback" :options="optionTimeHour" v-model="rewriteEndHour" @change="timeState" :disabled="isApproved() || isOnlyview()"></b-select>
                  </div>

                  <div class="mx-1">:</div>
                  <div class="WorkM_InputTimeGroup_InputItem">
                    <b-select size="sm" aria-describedby="input-time-live-feedback" :options="setOptionEndTimeMin" v-model="rewriteEndMin" @change="timeState" :disabled="isApproved() || isOnlyview()"></b-select>
                  </div>
                </div>
              </div>
            </div>
          </b-form-group>
          <!-- 工事 -->
          <b-form-group id="input-construction-live-feedback" :invalid-feedback="messageConstruction" :state="isConstructionState">
            <div class="WorkM_InputGroupArea mt-3" v-if="isAllocationCalc">
              <div class="WorkM_InputGroup_ItemLabel">工事</div>
              <div class="d-flex">
                <b-input
                type="number"
                size="sm"
                placeholder="工事CD"
                class="w-45"
                v-model="rewriteConstructionCode"
                @change="changeConstructionCode()"
                maxlength="4"
                :disabled="!setAttendanceCheck || isApproved() || isOnlyview()"
                aria-describedby="input-construction-live-feedback"
                >
                </b-input>
                <b-input size="sm" readonly v-model="rewriteConstructionName" :disabled="isApproved() || isOnlyview()"></b-input>
                <b-button variant="transparent" size="sm" class="WorkM_ButtonTempSuccess form-control-sm" :class="{'WorkEditModal_ButtonSearch': !setAttendanceCheck}" @click="btnSearchConstruction()" :disabled="!setAttendanceCheck || isApproved() || isOnlyview()">
                  <b-icon icon="search"></b-icon>
                </b-button>
              </div>
            </div>
          </b-form-group>
          <!-- 事由 -->
          <div class="WorkM_InputGroupArea mt-3">
            <div class="WorkM_InputGroup_ItemLabel">事由</div>
            <div>
              <b-form-group 
              id="input-note-live-feedback" 
              invalid-feedback="事由の文字数を40字以内にしてください。" 
              :state="noteSate()">
                <b-textarea 
                size="sm" 
                rows="2" 
                v-model="rewriteNote" 
                :disabled="isApproved() || isOnlyview()">
                </b-textarea>
              </b-form-group>
            </div>
          </div>
          <!-- 災害 -->
          <div class="mt-2">
            <b-checkbox :disabled="isDisasterFlg || isApproved() || isOnlyview()" size="sm" class="text-danger" v-model="rewriteDisasterKbn" value=1 unchecked-value=0>災害</b-checkbox>
          </div>

          <!-- 振替希望日入力 -->
          <div class="WorkM_InputGroupArea mt-3 d-flex">
            <b-button variant="transparent"
            size="sm"
            class="WorkM_ButtonTempSuccess form-control-sm"
            :class="{'WorkEditModal_ButtonSearch': !setKbnWorkCheck || isOnlyview()}"
            :disabled="!setKbnWorkCheck || isApproved() || isOnlyview()"
            style="min-width:135px;"
            @click="btnInputSubstituteHoliday()">
              振休希望日入力
            </b-button>
            <b-input
            type="number"
            size="sm"
            :placeholder=rewriteSubstituteHoliday
            v-model="rewriteSubstituteHoliday"
            :disabled=true
            >
            </b-input>
          </div>
          <!--  -->
          <div class="WorkM_InputGroupArea mt-3">
            <div class="WorkM_InputGroup_ItemLabel">申請先</div>
            <div style="height:27px;">
              <div v-if="proxyFlg" style="font-size:0.9rem;">（代）{{approvalUserName}}</div>
              <div v-else style="font-size:0.9rem;">{{approvalUserName}}</div>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
      <div class="mt-4">
        <div v-if="clickType == 0 && isApproved()" class="d-flex justify-content-between">
          <div v-if="approvalKbn == 1" class="WorkM_Button WorkM_ButtonDanger" @click="btnWorkDelete">取下げ</div>
          <div v-else class="WorkM_Button WorkM_ButtonDanger" @click="btnWorkDelete">削除</div>
          <div class="d-flex">
            <div class="WorkM_Button WorkM_ButtonConfirm ml-2" @click="btnClose">確認終了</div>
          </div>
        </div>
        <div v-else-if="clickType == 0" class="d-flex justify-content-between">
          <div class="WorkM_Button WorkM_ButtonDanger" @click="btnWorkDelete">削除</div>
          <div class="d-flex">
            <div class="WorkM_Button WorkM_ButtonSuccess" @click="btnWorkEdit" v-bind:class="{'disabled':!isChanged}">再送信</div>
            <div class="WorkM_Button WorkM_ButtonConfirm ml-2" @click="btnClose">確認終了</div>
          </div>
        </div>
        <div v-else-if="isOnlyview()" class="d-flex  justify-content-end">
          <div variant="transparent" class="WorkM_Button WorkM_ButtonConfirm" @click="btnClose">確認終了</div>
        </div>
        <div v-else class="d-flex justify-content-between flex-row-reverse">
          <div variant="transparent" class="WorkM_Button WorkM_ButtonSuccess" @click="btnWorkRegist">登録</div>
        </div>
      </div>
      <SearchConstructionModalVue ref="SearchConstructionModal" :loginUserId="String(shainCd)" :targetType="searchConstructionNumber" @selectConstruction="setConstruction"></SearchConstructionModalVue>
      <SelectSubstituteWorkModal ref="SelectSubstituteWorkModal" :loginUserId="shainCd" @setSubstituteWork="setSubstituteWork"></SelectSubstituteWorkModal>
      <InputSubstitudeHolidayModal
      ref="InputSubstitudeHolidayModal"
      :substituteHolidayInfo="substituteHolidayInfo"
      :loginUserId="shainCd"
      @setSubstituteHoliday="setSubstituteHoliday"></InputSubstitudeHolidayModal>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable */
import config from "../../const/config";
import SearchConstructionModalVue from "../Modal/SearchConstructionModal.vue";
import SelectSubstituteWorkModal from "../Modal/SelectSubstituteWorkModal.vue";
import InputSubstitudeHolidayModal from "./InputSubstitudeHolidayModal.vue";
export default {
  name: "ApplicationEditModal",
  components: {SearchConstructionModalVue, SelectSubstituteWorkModal, InputSubstitudeHolidayModal},
  props: {
    clickType:{type: Number, default: 0},
    message: { type: String, default: "" },
    selectApplication: {
      type: Object,
      default: () => {}
    },
  },
  data: function () {
    return {
      showModal: false,
      optionsWorkSegment: [],
      optionTimeHour: [
        { value: 0, text: "00" },
        { value: 1, text: "01" },
        { value: 2, text: "02" },
        { value: 3, text: "03" },
        { value: 4, text: "04" },
        { value: 5, text: "05" },
        { value: 6, text: "06" },
        { value: 7, text: "07" },
        { value: 8, text: "08" },
        { value: 9, text: "09" },
        { value: 10, text: "10" },
        { value: 11, text: "11" },
        { value: 12, text: "12" },
        { value: 13, text: "13" },
        { value: 14, text: "14" },
        { value: 15, text: "15" },
        { value: 16, text: "16" },
        { value: 17, text: "17" },
        { value: 18, text: "18" },
        { value: 19, text: "19" },
        { value: 20, text: "20" },
        { value: 21, text: "21" },
        { value: 22, text: "22" },
        { value: 23, text: "23" },
        { value: 24, text: "24" },
      ],
      optionTimeMin: [
        { value: 0, text: "00" },
        { value: 1, text: "01" },
        { value: 2, text: "02" },
        { value: 3, text: "03" },
        { value: 4, text: "04" },
        { value: 5, text: "05" },
        { value: 6, text: "06" },
        { value: 7, text: "07" },
        { value: 8, text: "08" },
        { value: 9, text: "09" },
        { value: 10, text: "10" },
        { value: 11, text: "11" },
        { value: 12, text: "12" },
        { value: 13, text: "13" },
        { value: 14, text: "14" },
        { value: 15, text: "15" },
        { value: 16, text: "16" },
        { value: 17, text: "17" },
        { value: 18, text: "18" },
        { value: 19, text: "19" },
        { value: 20, text: "20" },
        { value: 21, text: "21" },
        { value: 22, text: "22" },
        { value: 23, text: "23" },
        { value: 24, text: "24" },
        { value: 25, text: "25" },
        { value: 26, text: "26" },
        { value: 27, text: "27" },
        { value: 28, text: "28" },
        { value: 29, text: "29" },
        { value: 30, text: "30" },
        { value: 31, text: "31" },
        { value: 32, text: "32" },
        { value: 33, text: "33" },
        { value: 34, text: "34" },
        { value: 35, text: "35" },
        { value: 36, text: "36" },
        { value: 37, text: "37" },
        { value: 38, text: "38" },
        { value: 39, text: "39" },
        { value: 40, text: "40" },
        { value: 41, text: "41" },
        { value: 42, text: "42" },
        { value: 43, text: "43" },
        { value: 44, text: "44" },
        { value: 45, text: "45" },
        { value: 46, text: "46" },
        { value: 47, text: "47" },
        { value: 48, text: "48" },
        { value: 49, text: "49" },
        { value: 50, text: "50" },
        { value: 51, text: "51" },
        { value: 52, text: "52" },
        { value: 53, text: "53" },
        { value: 54, text: "54" },
        { value: 55, text: "55" },
        { value: 56, text: "56" },
        { value: 57, text: "57" },
        { value: 58, text: "58" },
        { value: 59, text: "59" },
      ],
      messageHourState: null,
      isAllocationCalc: true, // 工事CD入力要否フラグ
      isHourState: null,
      messageConstruction: null,
      isConstruction: true,
      isConstructionState: true,
      noteMaxLength: 40, // 事由MAX文字数
      constructionCodeMaxLength: 8, // 工事コードMAX文字数

      isChanged:false, // フォームの中、一つでも変更したか

      shiftStart: null,
      shiftEnd:null,
      targetDateInfo: {
        date: null,
        dateType: null,
      },
      applicationRemainInfo: {
        shainCd: 0,
        remainPaidHolidayDays: 0,
        paidLeaveYealyDays: 0,
        remainSubstituteHolidayTime:null,
        remainSubstituteHolidayDays: 0,
        overtimeWorkTime: null,
        overtimeMonthlyMaxHours: null
      },

      // 初期データ
      originallyInfo:{
        kbn: 0,
        date: null,
        dateType: null,
        start: null,
        end: null,
        startHour: null,
        startMin: null,
        endHour: null,
        endMin: null,
        substituteWork: null,
        substituteHoliday: {
          date:null,
          start:null,
          end:null
        },
        constructionCode: null,
        constructionName: null,
        reason:null,
        disasterKbn:null,
      },

      detailNo: 0,
      shainCd: 0, // 社員番号
      shainName: "", // 社員名
      rewriteApplicationKbn: 0, // 区分
      rewriteApplicationDate: "", // 日付
      rewriteApplicationDateTypeCode: 0,
      rewriteApplicationDateType: null, // (平日、休日、公休)
      rewriteSubstituteHoliday: null, // 振休入力欄
      substituteHolidayInfo:{ // 振休情報
        date:null,
        start:null,
        end:null,
      },
      rewriteSubstituteWork: null, // 振出入力欄
      substituteWorkInfo:{ // 振出情報
        detailNo:0,
        date:null,
        start:null,
        end:null,
        time:null,
      },
      rewriteStartHour: 0, // 開始時間
      rewriteStartMin: 0, // 開始分
      rewriteEndHour: 0, // 終了時間
      rewriteEndMin: 0, // 終了分
      rewriteConstructionCode: 0, // 工事cd
      rewriteConstructionName: null, // 工事名
      rewriteNote: "", // 事由
      rewriteDisasterKbn: 0, // 災害フラグ

      proxyFlg: false, // 代理フラグ
      approvalUserCd: null, // 申請先番号
      approvalUserName: null, // 申請先名
      approvalKbn: 0, // 承認結果CD

      dailyReportTermStart: "", // 日報期間開始日(yyyy/MM/dd)
      isDateState:null,
      messageDateState: "",
      isSegmentState:null,
      messageSegmentState: "区分を選択してください",
      isDisasterFlg: false, // 災害有効フラグ
      searchConstructionNumber: 2, // 工事検索ポップアップ_画面種別
    };
  },
  computed: {
    setAttendanceCheck: function(){
      let isAttendanceCheck = this.isAttendanceCheck();
      if(this.rewriteApplicationKbn > 0 && !this.emptyCheck(this.rewriteApplicationKbn)){
        if(!isAttendanceCheck){
          this.isConstructionState = null;
        }
        this.timeState();
      }
      return isAttendanceCheck;
    },
    setKbnHolidayCheck: function(){
      return this.isSubstituteHolidayCheck(this.rewriteApplicationKbn);
    },
    setKbnWorkCheck: function(){
      return this.isSubstituteWorkCheck(this.rewriteApplicationKbn);
    },
    setOptionStartTimeMin: function(){
      if(this.rewriteStartHour == 24){
        this.setStartTimeMin(0);
        return [{ value: 0, text: "00" }];
      }
      else{
        return this.optionTimeMin;
      }
    },
    setOptionEndTimeMin: function(){
      if(this.rewriteEndHour == 24){
        this.setEndTimeMin(0);
        return [{ value: 0, text: "00" }]
      }
      else{
        return this.optionTimeMin;
      }
    },
    dateStateMessage: function(){
      return "当月日報期間以降(" + this.dailyReportTermStart + ")で設定してください。";
    },
  },
  mounted: function () {
    this.optionsWorkSegment = config.OPTIONS.APPLIATION_SEGMENT;
    this.searchConstructionNumber = config.VALUE.DISPLAY_TYPE_APPLICATION;
  },
  methods: {
    openModal: function () {
      this.showModal = true;
      this.isSegmentState = null;
      this.isDateState = null;
      this.isConstructionState = true;
      this.isAllocationCalc = this.$store.state.flg_allocation_calc;
      this.isHourState = null;
    },
    handleOk: function () {
      // 初期表示フラグをfalseにする
      this.isInitialDisplay = false;
      this.showModal = false;
      this.$emit("handleOk");
    },

    // propsの情報を基に画面に表示する内容をセット
    setApplicationEditInfo: function(selectApplication){
      console.debug(JSON.stringify(selectApplication));
      console.debug("Object.keys(selectApplication).length  === 0" + Object.keys(selectApplication).length  === 0);
      if(selectApplication != null && Object.keys(selectApplication).length  > 0){
        let applicationInfoList = selectApplication.applicationInfoList;
        console.debug("applicationInfoList::: " + applicationInfoList.shainName);
        this.shiftStart = selectApplication.shiftStart;
        this.shiftEnd = selectApplication.shiftEnd;
        this.targetDateInfo = selectApplication.targetDateInfo;
        //明細Noセット
        this.detailNo = applicationInfoList.slipNo;
        // ユーザ情報をセット
        this.shainCd = applicationInfoList.shainCd;
        this.shainName = applicationInfoList.shainName;
        // 日付情報をセット
        this.rewriteApplicationDate = this.getStrDateHyphen(applicationInfoList.applicationTargetDate);
        this.dailyReportTermStart = selectApplication.targetDateInfo.dailyreportTermStart;
        // 区分情報をセット
        this.rewriteApplicationKbn = applicationInfoList.applicationKbn;
        //時間情報をセット
        let [timeStartHourStr, timeStartMinStr] = [0,0]
        let [timeEndHourStr, timeEndMinStr]= [0,0]
        if(!this.emptyCheck(applicationInfoList.applicationTargetStartTime)){
          [timeStartHourStr, timeStartMinStr] = applicationInfoList.applicationTargetStartTime?.split(':');
        }
        if(!this.emptyCheck(applicationInfoList.applicationTargetEndTime)){
          [timeEndHourStr, timeEndMinStr] = applicationInfoList.applicationTargetEndTime?.split(':');
        }
        this.rewriteStartHour = parseInt(timeStartHourStr);
        this.rewriteStartMin = parseInt(timeStartMinStr);
        this.rewriteEndHour = parseInt(timeEndHourStr);
        this.rewriteEndMin = parseInt(timeEndMinStr);
        // 工事情報をセット
        this.rewriteConstructionCode = (applicationInfoList.constructionCode == 0 ? "" : applicationInfoList.constructionCode);
        this.rewriteConstructionName = (applicationInfoList.constructionCode == 0 ? "" : applicationInfoList.constructionName);
        // 事由情報をセット
        this.rewriteNote = applicationInfoList.applicationReason;
        // 災害情報をセット
        this.rewriteDisasterKbn = applicationInfoList.disasterKbn;
        // 区分が振休なら振出選択入力欄に値を入れる
        if(this.rewriteApplicationKbn == 7 && !this.emptyCheck(applicationInfoList.transferWorkDate)){
          this.substituteWorkInfo.detailNo = applicationInfoList.workDetailNo
          this.substituteWorkInfo.date = applicationInfoList.transferWorkDate;
          this.substituteWorkInfo.start = applicationInfoList.transferWorkStartDate;
          this.substituteWorkInfo.end = applicationInfoList.transferWorkEndDate;
          this.substituteWorkInfo.time = applicationInfoList.transferWorkWorkingTime;
          this.rewriteSubstituteWork = this.substituteWorkInfo.date + " " + this.substituteWorkInfo.start + "～" + this.substituteWorkInfo.end + " (" + this.substituteWorkInfo.time + ")";
          this.rewriteSubstituteHoliday = null;
        }
        // 区分が振出なら振休希望日入力欄に値を入れる
        else if((this.rewriteApplicationKbn == 11 || this.rewriteApplicationKbn == 21) && !this.emptyCheck(applicationInfoList.planSubstituteHolidayDate)){
          this.substituteHolidayInfo.date = applicationInfoList.planSubstituteHolidayDate;
          this.substituteHolidayInfo.start = applicationInfoList.planSubstituteHolidayStartTime;
          this.substituteHolidayInfo.end = applicationInfoList.planSubstituteHolidayEndTime;
          this.rewriteSubstituteHoliday = this.substituteHolidayInfo.date + " " + this.substituteHolidayInfo.start + "～" + this.substituteHolidayInfo.end;
          this.rewriteSubstituteWork = null;
        }
        else {
          this.substituteWorkInfo.detailNo = 0;
          this.substituteWorkInfo.date = null;
          this.substituteWorkInfo.start = null;
          this.substituteWorkInfo.end = null;
          this.substituteWorkInfo.time = null;
          this.rewriteSubstituteWork = null;

          this.substituteHolidayInfo.date = null;
          this.substituteHolidayInfo.start = null;
          this.substituteHolidayInfo.end = null;
          this.rewriteSubstituteHoliday = null;
        }
        // 申請先情報をセット
        this.proxyFlg = (applicationInfoList.isApprovalDutyAgent == 1);
        this.approvalUserCd = applicationInfoList.approvalShainCd;
        this.approvalUserName = applicationInfoList.approvalShainName;
        this.approvalKbn = applicationInfoList.approvalKbn;
        console.log("approvalKbn: " + this.approvalKbn);

        this.originallyInfo.date = this.getStrDateHyphen(applicationInfoList.applicationTargetDate);
        this.originallyInfo.dateType = this.rewriteApplicationDateType;
        this.originallyInfo.kbn = this.rewriteApplicationKbn;
        this.originallyInfo.start = applicationInfoList.applicationTargetStartTime;
        this.originallyInfo.end = applicationInfoList.applicationTargetEndTime;
        this.originallyInfo.startHour = this.rewriteStartHour;
        this.originallyInfo.startMin = this.rewriteStartMin;
        this.originallyInfo.endHour = this.rewriteEndHour;
        this.originallyInfo.endMin = this.rewriteEndMin;
        this.originallyInfo.substituteWork = this.substituteWorkInfo.detailNo;
        // deepcopy
        this.originallyInfo.substituteHoliday.date = this.substituteHolidayInfo.date;
        this.originallyInfo.substituteHoliday.start = this.substituteHolidayInfo.start;
        this.originallyInfo.substituteHoliday.end = this.substituteHolidayInfo.end;
        this.originallyInfo.constructionCode = this.rewriteConstructionCode;
        this.originallyInfo.constructionName = this.rewriteConstructionName;
        this.originallyInfo.disasterKbn = this.rewriteDisasterKbn;
        this.originallyInfo.reason = this.rewriteNote;

        console.log("originallyInfo：" + JSON.stringify(this.originallyInfo));

        // 有休残情報をセット
        this.applicationRemainInfo = selectApplication.applicationRemainInfo;
        if(this.emptyCheck(this.originallyInfo.dateType)){
          this.getOriginallyDateType();
        }
      }
    },

    // ヘッダータイトルをセット
    setHeaderTitle: function(clickType){
      console.debug("clickType：" + clickType);
      const TITLE_APPLICATION_UPDATE = "事前申請編集";
      const TITLE_APPLICATION_REGIST = "事前申請登録";
      const TITLE_APPLICATION_DETAIL = "事前申請詳細";
      if(clickType == 0){
        return TITLE_APPLICATION_UPDATE;
      }
      else if(this.isOnlyview()){
        return TITLE_APPLICATION_DETAIL;
      }
      else{
        return TITLE_APPLICATION_REGIST;
      }
    },
    setClearInfo: function(){
        // 日付情報をセット
        this.rewriteApplicationDate = null;
        this.rewriteApplicationDateTypeCode = 0;
        this.rewriteApplicationDateType = null;
        // 区分情報をセット
        this.rewriteApplicationKbn = 0;
        //時間情報をセット
        this.rewriteStartHour = null;
        this.rewriteStartMin = null;
        this.rewriteEndHour = null;
        this.rewriteEndMin = null;
        // 工事情報をセット
        this.rewriteConstructionCode = null;
        this.rewriteConstructionName = null;
        // 事由情報をセット
        this.rewriteNote = null;
        // 災害情報をセット
        this.rewriteDisasterKbn = 0;
        // 振休振出情報をセット
        this.rewriteSubstituteWork = null;
        this.rewriteSubstituteHoliday = null;
        // 申請先情報をセット
        this.proxyFlg = false;
        this.approvalUserCd = null;
        this.approvalUserName = null;
    },

    // 登録ボタン押下時イベント（新規登録）
    btnWorkRegist: async function(){
      this.getConstructionValueFromAPI().then(()=>{

        //=====================================

        // 区分は選択されているか
        let isValidSegment = this.selectSegmentRest();
        if (isValidSegment == null) {
          isValidSegment = true;
        }
        // 正常な時間がセットされているか
        let isValidTime = this.timeState();
        if (isValidTime == null) {
          isValidTime = true;
        }
        let isAttendance = this.isAttendanceCheck();

        // 日付が日報期間内かどうか
        if (this.dateState()) {
          return;
        }

        // 事由の文字数は40字以下か？
        if (!this.noteSate()) {
          return;
        }

        // 割賦配布ではない、または就業区分が出勤系ではない、または工事コードが正常、
        const isValidConstruction = !this.isAllocationCalc || !isAttendance ||this.isConstructionState;
        if (!isValidSegment || !isValidTime || !isValidConstruction) {
          return;
        }
        //=======================================

        // 工事コード
        let constructionCode = (this.rewriteConstructionCode == "" || !isAttendance) ? 0 : this.rewriteConstructionCode;
        // 災害フラグ
        let disasterKbn;
        if(this.isDisasterFlg){
          disasterKbn = 0;
        }
        else{
          disasterKbn = (this.rewriteDisasterKbn == "" || this.rewriteDisasterKbn == null) ? 0 : this.rewriteDisasterKbn;
        }
        let substituteWorkInfo = {
          detailNo:0,
          date:null,
          start:null,
          end:null,
          time:null,
        };
        let substituteHolidayInfo = {
          date:null,
          start:null,
          end:null,
        };
        // 振出情報
        if(this.isSubstituteHolidayCheck(this.rewriteApplicationKbn)){
          substituteWorkInfo = {
            detailNo:this.substituteWorkInfo.detailNo,
            date:this.substituteWorkInfo.date,
            start:this.substituteWorkInfo.start,
            end:this.substituteWorkInfo.end,
            time:this.substituteWorkInfo.time,
          };
        }
        // 振休情報
        else if(this.isSubstituteWorkCheck(this.rewriteApplicationKbn)){
          substituteHolidayInfo = {
            date:this.substituteHolidayInfo.date,
            start:this.substituteHolidayInfo.start,
            end:this.substituteHolidayInfo.end,
          }
        }

        // 送信前のパラメータ設定
        let json = {
          shainCd: this.shainCd,
          applicationKbn: this.rewriteApplicationKbn,
          applicationTargetDate: this.getStrDateSlash(this.rewriteApplicationDate),
          applicationTargetStartTime: this.optionTimeHour[this.rewriteStartHour].text + ":" + this.optionTimeMin[this.rewriteStartMin].text,
          applicationTargetEndTime: this.optionTimeHour[this.rewriteEndHour].text + ":" + this.optionTimeMin[this.rewriteEndMin].text,
          constructionCode: constructionCode,
          disasterKbn: disasterKbn,
          applicationReason: this.rewriteNote,
          approvalShainCd: this.approvalUserCd,
          isApprovalDutyAgent: this.proxyFlg ? 1 : 0,
          workDetailNo:substituteWorkInfo.detailNo,
          transferWorkDate:substituteWorkInfo.date,
          transferWorkStartDate:substituteWorkInfo.start,
          transferWorkEndDate:substituteWorkInfo.end,
          transferWorkWorkingTime:substituteWorkInfo.time,

          planSubstituteHolidayDate:substituteHolidayInfo.date,
          planSubstituteHolidayStartTime:substituteHolidayInfo.start,
          planSubstituteHolidayEndTime:substituteHolidayInfo.end,
        }
        console.log("approvalShainCd：" + this.approvalUserCd);
        console.log("json：" + JSON.stringify(json));

        let message = "以下の事前申請を登録します。"
                    + "<br>・区分：" + this.getDispSegment(this.rewriteApplicationKbn)
                    + "<br>・日付：" + this.getStrDateSlash(this.rewriteApplicationDate) + "(" + this.getDayOfWeek(this.rewriteApplicationDate) + ")（" + this.rewriteApplicationDateType + "）"
                    + "<br>・時間：" + json.applicationTargetStartTime
                    + " ～ " + json.applicationTargetEndTime;

        // 過去日付かチェック
        let today = new Date();
        let todayStr = new Date(this.getStrDateSlash(today));
        let targetDay = new Date(this.getStrDateSlash(this.rewriteApplicationDate));
        if(targetDay < todayStr){
          message = message + "<br> <label style='color:red;'>＊過去の事前申請です。</label>";
        }
        message = message + "<br>よろしいですか？";

        this.$confirm(message, "確認", {
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            dangerouslyUseHTMLString: true,
            customClass:"editCheckModalWidthHeader"
          }).then(() => {
            // 新規登録
            this.postData(config.URL.APPLICATION_REGIST, json)
              .then((response) => {
                console.debug("response：" + JSON.stringify(response));
                // レスポンスの結果がfalseならエラーメッセージを表示
                if(!response.result){
                  this.showAlertError(response.message);
                  return;
                }
                this.$emit("getApplicationRegistInfo");
                this.setClearInfo();
                this.showModal = false;
                this.$emit("handleOk");
              })
              .catch((e) => {
                // Note: エラーメッセージは、共通処理で表示している
                console.error(e);
              })
              .finally(() => {});
          });
      });
    },
    // 更新ボタン押下時イベント（更新）
    btnWorkEdit: async function(){
      if(!this.isChanged){
        return;
      }
      this.getConstructionValueFromAPI().then(()=>{

        //=====================================
        // 区分は選択されているか
        let isValidSegment= this.selectSegmentRest();
        if(isValidSegment == null){
          isValidSegment = true;
        }
        // 正常な時間がセットされているか
        let isValidTime = this.timeState();
        if(isValidTime == null){
          isValidTime = true;
        }
        let isAttendance = this.isAttendanceCheck();

        // 日付が日報期間内かどうか
        if(this.dateState()){
          return;
        }

        // 事由の文字数は20字以下か？
        if(!this.noteSate()){
          return;
        }

        // 割賦配布ではない、または就業区分が出勤系ではない、または工事コードが正常、
        const isValidConstruction = !this.isAllocationCalc || !isAttendance ||this.isConstructionState;
        if(!isValidSegment || !isValidTime || !isValidConstruction){
          return;
        }
        //=======================================
        // 工事コード
        let constructionCode = (this.rewriteConstructionCode == "" || !isAttendance) ? 0 : this.rewriteConstructionCode;
        // 災害フラグ
        let disasterKbn;
        if(this.isDisasterFlg){
          disasterKbn = 0;
        }
        else{
          disasterKbn = (this.rewriteDisasterKbn == "" || this.rewriteDisasterKbn == null) ? 0 : this.rewriteDisasterKbn;
        }
        let substituteWorkInfo = {
          detailNo:0,
          date:null,
          start:null,
          end:null,
          time:null,
        };
        let substituteHolidayInfo = {
          date:null,
          start:null,
          end:null,
        };
        // 振出情報
        if(this.isSubstituteHolidayCheck(this.rewriteApplicationKbn)){
          substituteWorkInfo = {
            detailNo:this.substituteWorkInfo.detailNo,
            date:this.substituteWorkInfo.date,
            start:this.substituteWorkInfo.start,
            end:this.substituteWorkInfo.end,
            time:this.substituteWorkInfo.time,
          };
        }
        // 振休情報
        else if(this.isSubstituteWorkCheck(this.rewriteApplicationKbn)){
          substituteHolidayInfo = {
            date:this.substituteHolidayInfo.date,
            start:this.substituteHolidayInfo.start,
            end:this.substituteHolidayInfo.end,
          }
        }
        // 送信前のパラメータ設定
        let json = {
          shainCd: this.shainCd,
          // applicationDate: this.targetDateInfo.date,
          applicationKbn: this.rewriteApplicationKbn,
          applicationTargetDate: this.getStrDateSlash(this.rewriteApplicationDate),
          applicationTargetStartTime: this.optionTimeHour[this.rewriteStartHour].text + ":" + this.optionTimeMin[this.rewriteStartMin].text,
          applicationTargetEndTime: this.optionTimeHour[this.rewriteEndHour].text + ":" + this.optionTimeMin[this.rewriteEndMin].text,
          constructionCode: constructionCode,
          disasterKbn: disasterKbn,
          applicationReason: this.rewriteNote,
          approvalShainCd: this.approvalUserCd,
          isApprovalDutyAgent: this.proxyFlg ? 1 : 0,
          workDetailNo:substituteWorkInfo.detailNo,
          transferWorkDate:substituteWorkInfo.date,
          transferWorkStartDate:substituteWorkInfo.start,
          transferWorkEndDate:substituteWorkInfo.end,
          transferWorkWorkingTime:substituteWorkInfo.time,

          planSubstituteHolidayDate:substituteHolidayInfo.date,
          planSubstituteHolidayStartTime:substituteHolidayInfo.start,
          planSubstituteHolidayEndTime:substituteHolidayInfo.end,

          slipNo: this.detailNo
        };
        console.debug("json：" + JSON.stringify(json));

        // 更新前ポップアップ
        let message = "事前申請を以下の通りに更新します。"
                    + "<br>・区分：" + this.getDispSegment(this.rewriteApplicationKbn)
                    + "<br>・日付：" + this.getStrDateSlash(this.rewriteApplicationDate) + "(" + this.getDayOfWeek(this.rewriteApplicationDate) + ")（" + this.rewriteApplicationDateType + "）"
                    + "<br>・時間：" + json.applicationTargetStartTime
                    + " ～ " + json.applicationTargetEndTime;

        // 過去日付かチェック
        let today = new Date();
        let todayStr = new Date(this.getStrDateSlash(today));
        let targetDay = new Date(this.getStrDateSlash(this.rewriteApplicationDate));
        if(targetDay < todayStr){
          message = message + "<br> <label style='color:red;'>＊過去の事前申請です。</label>";
        }
        message = message + "<br>よろしいですか？";

        this.$confirm(message, "確認", {
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            dangerouslyUseHTMLString: true,
            customClass:"editCheckModalWidthHeader"
          }).then(() => {
          // 更新
          this.putData(config.URL.APPLICATION_REGIST, null, json)
            .then((response) => {
              console.debug("response：" + JSON.stringify(response));
              // レスポンスの結果がfalseならエラーメッセージを表示
              if(!response.result){
                this.showAlertError(response.message);
                return;
              }
              this.$emit("getApplicationRegistInfo");
              this.setClearInfo();
              this.showModal = false;
              this.$emit("handleOk");
            })
            .catch((e) => {
              // Note: エラーメッセージは、共通処理で表示している
              console.error(e);
            })
            .finally(() => {});
        });
      })
    },
    // 削除ボタン押下時イベント（削除）
    btnWorkDelete: function(){
      if(this.emptyCheck(this.originallyInfo.dateType)){
        this.getOriginallyDateType();
      }
      let shainCd = String(this.shainCd);
      let detailNo = this.detailNo;
      let json = {
        shainCd: shainCd,
        detailNo: detailNo
      };
      console.log("json：" + JSON.stringify(json));
      let message = "以下の事前申請を削除します。"
                  + "<br>・区分：" + this.getDispSegment(this.originallyInfo.kbn)
                  + "<br>・日付：" + this.getStrDateSlash(this.originallyInfo.date) + "(" + this.getDayOfWeek(this.originallyInfo.date) + ")（" + this.originallyInfo.dateType + "）"
                  + "<br>・時間：" + this.originallyInfo.start
                  + " ～ " + this.originallyInfo.end;
      if(this.approvalKbn == config.VALUE.APPROVAL_TYPE_APPROVAL){
        message = message + "<br> <label style='color:red;'>＊すでに承認されている事前申請です。</label>";
      } else if(this.approvalKbn == config.VALUE.APPROVAL_TYPE_REJECTION){
        message = message + "<br> <label style='color:red;'>＊すでに否認されている事前申請です。</label>";
      }
      message = message + "<br>よろしいですか？";
      this.$confirm(message, "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          dangerouslyUseHTMLString: true,
          customClass:"editCheckModalWidthHeader"
        }).then(() => {
          this.deleteDataMultiKey(config.URL.APPLICATION_REGIST, shainCd, detailNo)
            .then((response) => {
              console.debug("response：" + JSON.stringify(response));
              // レスポンスの結果がfalseならエラーメッセージを表示
              if(!response.result){
                this.showAlertError(response.message);
                return;
              }
              this.$emit("getApplicationRegistInfo");
              this.setClearInfo();
              this.showModal = false;
              this.$emit("handleOk");
            })
            .catch((e) => {
              // Note: エラーメッセージは、共通処理で表示している
              console.error(e);
            })
            .finally(() => {});
        })
    },
    btnClose: function() {
      if (this.isChanged) {
        let message = "事前申請内容が変更されていますが、再送信せずに閉じます。<br>よろしいですか？";
        this.$confirm(message, "確認", {
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            dangerouslyUseHTMLString: true,
            customClass:"editCheckModalWidthHeader"
          }).then(() => {
            this.$emit("getApplicationRegistInfo");
            this.showModal = false;
            this.$emit("handleOk");
          })
      } else {
        this.$emit("getApplicationRegistInfo");
        this.showModal = false;
        this.$emit("handleOk");
      }
    },
    // 出勤かチェックする
    // true：出勤
    // false：休み
    isAttendanceCheck: function() {
      const WORK_SEGMENT_EARLY_START = 1; // 早出
      const WORK_SEGMENT_OVERTIME = 2; // 残業
      const WORK_SEGMENT_HOLIDAY_TRANSFER = 11; // 休日出勤（振替）
      const WORK_SEGMENT_HOLIDAY_ALLOWANCE = 12; // 休日出勤（残業）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER = 21; // 公休出勤（振替）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE = 22; // 公休出勤（残業）

      if (this.rewriteApplicationKbn != WORK_SEGMENT_EARLY_START
        && this.rewriteApplicationKbn != WORK_SEGMENT_OVERTIME
        && this.rewriteApplicationKbn != WORK_SEGMENT_HOLIDAY_TRANSFER
        && this.rewriteApplicationKbn != WORK_SEGMENT_HOLIDAY_ALLOWANCE
        && this.rewriteApplicationKbn != WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER
        && this.rewriteApplicationKbn != WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE
        && this.rewriteApplicationKbn > 0) {
        return false;
      } else {
        return true;
      }
    },
    // 振出かチェックする
    // true：振出
    // false：休み
    isSubstituteWorkCheck: function() {
      const WORK_SEGMENT_HOLIDAY_TRANSFER = 11; // 休日出勤（振替）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER = 21; // 公休出勤（振替）

      if (this.rewriteApplicationKbn != WORK_SEGMENT_HOLIDAY_TRANSFER
          && this.rewriteApplicationKbn != WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER) {
        return false;
      } else {
        return true;
      }
    },
    // 振休かチェックする
    // true：振休
    // false：休み
    isSubstituteHolidayCheck: function() {
      const WORK_SEGMENT_WORK_TRANSFER = 7; // 振休

      if (this.rewriteApplicationKbn != WORK_SEGMENT_WORK_TRANSFER) {
        return false;
      } else {
        return true;
      }
    },
    // 早出かチェックする
    // true：早出
    // false：休み
    isEarlyStartCheck: function() {
      const WORK_SEGMENT_EARLY_START = 1; // 早出

      if (this.rewriteApplicationKbn != WORK_SEGMENT_EARLY_START) {
        return false;
      } else {
        return true;
      }
    },
    // 残業かチェックする
    // true：残業
    // false：休み
    isOvertimeCheck: function() {
      const WORK_SEGMENT_OVERTIME = 2; // 残業

      if (this.rewriteApplicationKbn != WORK_SEGMENT_OVERTIME) {
        return false;
      } else {
        return true;
      }
    },
    // ×(遅刻)かチェックする
    // true：×(遅刻)
    // false
    isLateCheck: function() {
      const WORK_SEGMENT_LATE = 8; // ×(遅刻)

      if (this.rewriteApplicationKbn != WORK_SEGMENT_LATE) {
        return false;
      } else {
        return true;
      }
    },
    // ★その他(早退)かチェックする
    // true：★その他(早退)
    // false
    isLeaveCheck: function() {
      const WORK_SEGMENT_LEAVE = 9; // ★その他(早退)

      if (this.rewriteApplicationKbn != WORK_SEGMENT_LEAVE) {
        return false;
      } else {
        return true;
      }
    },
    // 検索ボタン押下時イベント
    btnSearchConstruction: function() {
      this.$refs.SearchConstructionModal.openModal();
    },
    // 振出ボタン押下時イベント
    btnSelectSubstituteWork: function() {
      this.$refs.SelectSubstituteWorkModal.openModal();
    },
    // 振出選択入力欄に帰ってきた値をセット
    setSubstituteWork: function(value) {
      console.debug("value：" + JSON.stringify(value));
      this.substituteWorkInfo.detailNo = value.detailNo;
      this.substituteWorkInfo.date = this.getStrDateSlash(value.date);
      this.substituteWorkInfo.start = value.start;
      this.substituteWorkInfo.end = value.end;
      this.substituteWorkInfo.time = value.time;
      this.rewriteSubstituteWork = this.substituteWorkInfo.date + " " + this.substituteWorkInfo.start + "～" + this.substituteWorkInfo.end + " (" + this.substituteWorkInfo.time + ")";
    },
    // 振休ボタン押下時イベント
    btnInputSubstituteHoliday: function() {
      if (this.emptyCheck(this.rewriteSubstituteHoliday)) {
        this.substituteHolidayInfo.date = this.rewriteApplicationDate;
        this.substituteHolidayInfo.start = this.optionTimeHour[this.rewriteStartHour].text + ":" + this.optionTimeMin[this.rewriteStartMin].text;
        this.substituteHolidayInfo.end = this.optionTimeHour[this.rewriteEndHour].text + ":" + this.optionTimeMin[this.rewriteEndMin].text;
      }
      console.log("substituteHolidayInfo：" + JSON.stringify(this.substituteHolidayInfo));
      this.$refs.InputSubstitudeHolidayModal.openModal();
    },
    // 振休希望日入力欄に帰ってきた値をセット
    setSubstituteHoliday: function(value) {
      console.debug("value：" + JSON.stringify(value));
      this.substituteHolidayInfo.date = this.getStrDateSlash(value.date);
      this.substituteHolidayInfo.start = value.start;
      this.substituteHolidayInfo.end = value.end;
      this.rewriteSubstituteHoliday = this.substituteHolidayInfo.date + " " + this.substituteHolidayInfo.start + "～" + this.substituteHolidayInfo.end;
    },
    // 区分コードを基に区分名を取得
    // segmentCd:区分コード
    getDispSegment: function (segmentCd) {
      let optionSegment = config.OPTIONS.APPLIATION_SEGMENT;
      let result = "";
      optionSegment.forEach((element) => {
        if (element.value == segmentCd) {
          result = element.text;
        }
      });
      return result;
    },
    // 変更した日付が「平日」、「休日」、「公休」かを取得
    changeDate: function(date) {
      console.log("date：" + date);
      let paramList = {
          shainCd: this.shainCd,
          targetDate: this.getStrDateSlash(this.rewriteApplicationDate),
      }
      console.debug("paramList：" + JSON.stringify(paramList));
      this.getWithParams(config.URL.USER_INFO_DATE_TYPE, paramList)
        .then((response) => {
          if (response.result) {
            console.debug("response：" + JSON.stringify(response.container));
            if (response.container.dayInfo) {
              this.isErrorGetShfitFlg = false;
              this.originallyInfo.dateType = response.container.dayInfo.dateType;
              this.rewriteApplicationDateType = response.container.dayInfo.dateType;
              this.rewriteApplicationDateTypeCode = response.container.dayInfo.dateTypeCode;
              this.isBeforeDailyreportTerm = response.container.dayInfo.isBeforeDailyreportTerm;
              this.dailyReportTermStart = response.container.dayInfo.dailyreportTermStart;
              this.dateState();

              this.setWorkSegment(response.container.dayInfo.dateTypeCode);
            }
            if (response.container.applicationRemainInfo) {
              // 有休残情報をセット
              this.applicationRemainInfo = response.container.applicationRemainInfo;
            }
          } else {
            this.isErrorGetShfitFlg = true;
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {
          if(this.rewriteApplicationKbn > 0 && !this.emptyCheck(this.rewriteApplicationKbn)){
            this.selectSegmentRest();
          }
        });
    },
    // 初期日付が「平日」、「休日」、「公休」かを取得
    getOriginallyDateType: function(){
      console.log();
      let paramList = {
          shainCd: this.shainCd,
          targetDate: this.getStrDateSlash(this.originallyInfo.date),
      }
      console.debug("paramList：" + JSON.stringify(paramList));
      this.getWithParams(config.URL.USER_INFO_DATE_TYPE, paramList)
        .then((response) => {
          if (response.result) {
            console.debug("response：" + JSON.stringify(response.container));
            if (response.container.dayInfo) {
              this.isErrorGetShfitFlg = false;
              this.originallyInfo.dateType = response.container.dayInfo.dateType;
              this.rewriteApplicationDateType = response.container.dayInfo.dateType;
              this.rewriteApplicationDateTypeCode = response.container.dayInfo.dateTypeCode;
              this.isBeforeDailyreportTerm = response.container.dayInfo.isBeforeDailyreportTerm;
              this.dailyReportTermStart = response.container.dayInfo.dailyreportTermStart;
              this.dateState();

              this.setWorkSegment(response.container.dayInfo.dateTypeCode);
            }
            if (response.container.applicationRemainInfo) {
              // 有休残情報をセット
              this.applicationRemainInfo = response.container.applicationRemainInfo;
            }
          } else {
            this.isErrorGetShfitFlg = true;
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
    },
    // 日付区分に基づいて、区分Listを更新
    setWorkSegment(dateTypeCode) {
      switch (dateTypeCode) {
        case config.VALUE.DATE_TYPE_HOLIDAY:
          this.optionsWorkSegment = config.OPTIONS.APPLIATION_SEGMENT_HOLIDAY;
          break;
        case config.VALUE.DATE_TYPE_PUBLIC_HOLIDAY:
          this.optionsWorkSegment = config.OPTIONS.APPLIATION_SEGMENT_PUBLIC_HOLIDAY;
          break;
        case config.VALUE.DATE_TYPE_WEEKDAY:
        default:
          this.optionsWorkSegment = config.OPTIONS.APPLIATION_SEGMENT_WEEKDAY;
          break;
      }
    },
    // 開始時間が24にセットされたとき、分は0にする。
    setStartTimeMin(min){
      this.rewriteStartMin = min;
    },
    // 終了時間が24にセットされたとき、分は0にする。
    setEndTimeMin(min){
      this.rewriteEndMin = min;
    },
    // 区分選択済チェック
    // null: 選択済
    // false: 未選択
    segmentState() {
      this.isDisasterFlg = !this.isAttendanceCheck();
      this.isSegmentState = this.rewriteApplicationKbn > 0 ? null: false
      if(this.isSegmentState){
        this.selectSegmentRest();
      }
      return this.isSegmentState
    },
    // 日付が「平日」ではない時、区分に「有休、振休、特休、他振、欠勤」が選ばれていないかチェック
    // 平日に「有休、振休、特休、他振、欠勤」が選ばれている
    selectSegmentRest() {
      this.isDisasterFlg = !this.isAttendanceCheck();
      const WORK_SEGMENT_HOLIDAY_TRANSFER = 11;         // 勤務区分: 休日出勤（振替）
      const WORK_SEGMENT_HOLIDAY_ALLOWANCE = 12;        // 勤務区分: 休日出勤（残業）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER = 21;  // 勤務区分: 公休出勤（振替）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE = 22; // 勤務区分: 公休出勤（残業）
      const MSG_ERROR_SELECT_WORK_SEGMENT = "対象日付が「平日」の場合、「早出、残業、欠勤、有休、特休、他振、振休、★その他」から選択してください。";
      const MSG_ERROR_SELECT_REST_SEGMENT = "対象日付が「休日」の場合、「休日出勤（振替）、休日出勤（残業）」から選択してください。";
      const MSG_ERROR_SELECT_PUBLIC_HOLIDAY_SEGMENT = "対象日付が「公休」の場合、「公休出勤（振替）、公休出勤（残業）」から選択してください。";
      const MSG_ERROR_NON_SELECT_SEGMENT = "区分を選択してください";

      if (this.rewriteApplicationKbn <= 0) {
        // 区分未選択
        this.messageSegmentState = MSG_ERROR_NON_SELECT_SEGMENT;
        this.isSegmentState = false;
      } else {
        // 区分選択 -> 日付区分と一致するかチェック
        switch (this.rewriteApplicationDateTypeCode) {
          case config.VALUE.DATE_TYPE_HOLIDAY:
            // 休日 -> 休日系以外はNG
            if (this.rewriteApplicationKbn != WORK_SEGMENT_HOLIDAY_TRANSFER
                && this.rewriteApplicationKbn != WORK_SEGMENT_HOLIDAY_ALLOWANCE) {
              this.messageSegmentState = MSG_ERROR_SELECT_REST_SEGMENT;
              this.isSegmentState = false;
            } else {
              this.isSegmentState = null;
            }
            break;
          case config.VALUE.DATE_TYPE_PUBLIC_HOLIDAY:
            // 公休 -> 公休系以外はNG
            if (this.rewriteApplicationKbn != WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER
                && this.rewriteApplicationKbn != WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE) {
              this.messageSegmentState = MSG_ERROR_SELECT_PUBLIC_HOLIDAY_SEGMENT;
              this.isSegmentState = false;
            } else {
              this.isSegmentState = null;
            }
            break;
          case config.VALUE.DATE_TYPE_WEEKDAY:
          default:
            // 平日 -> 休日／公休系はNG
            if (this.rewriteApplicationKbn == WORK_SEGMENT_HOLIDAY_TRANSFER
                || this.rewriteApplicationKbn == WORK_SEGMENT_HOLIDAY_ALLOWANCE
                || this.rewriteApplicationKbn == WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER
                || this.rewriteApplicationKbn == WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE) {
              this.messageSegmentState = MSG_ERROR_SELECT_WORK_SEGMENT;
              this.isSegmentState = false;
            } else {
              this.isSegmentState = null;
            }
            break;
        }
      }
      return this.isSegmentState;
    },
    // 事由文字数チェック
    noteSate(){
      return this.rewriteNote?.length <= this.noteMaxLength || this.emptyCheck(this.rewriteNote);
    },
    dateState(){
      if (this.isBeforeDailyreportTerm && !this.isOnlyview()) {
        this.isDateState = false;
        this.messageDateState = this.dateStateMessage;
      } else {
        this.isDateState = null;
      }
      return this.isBeforeDailyreportTerm;
    },
    // 時間FromTo入力内容チェック
    // 早出：開始時刻はシフト開始より前
    // 残業：終了時刻はシフト終了より後
    // ×(遅刻)、★その他(早退)：開始時刻はシフト開始時刻以降で、終了時刻はシフト終了時刻以前
    timeState() {
      const MSG_ERR_TIME_REVERCE = "入力時間が逆転しています。";
      const MSG_ERR_TIME_EMPTY = "時間を入力してください。";
      const MSG_ERR_TIME_SAME = "FromとToに同じ時間が入力されています。"
      const MSG_ERR_EARLY_START = "開始時刻にシフト開始より前の時間を入力してください。";
      const MSG_ERR_OVERWORK = "終了時刻にシフト終了より後の時間を入力してください。";
      const MSG_ERR_LATE_BEFORE = "開始時刻にシフト開始より後の時間を入力してください。";
      const MSG_ERR_LATE_AFTER = "開始時刻にシフト終了より前の時間を入力してください。";
      const MSG_ERR_LEAVE_BEFORE = "終了時刻にシフト開始より後の時間を入力してください。";
      const MSG_ERR_LEAVE_AFTER = "終了時刻にシフト終了より前の時間を入力してください。";
      const MSG_ERR_SHIFT_START_BEFORE = "開始時刻にシフト開始以降の時間を入力してください。";
      const MSG_ERR_SHIFT_END_AFTER = "終了時刻にシフト終了以前の時間を入力してください。";

      // 時間入力欄の内一つでも値が入っていないならメッセージを表示
      if(isNaN(this.rewriteStartHour) || isNaN(this.rewriteStartMin) || isNaN(this.rewriteEndHour) || isNaN(this.rewriteEndMin)){
        console.log(MSG_ERR_TIME_EMPTY);
        this.messageHourState = MSG_ERR_TIME_EMPTY;
        this.isHourState = false;
        return this.isHourState;
      }

      // 入力された時間のToがFromよりも小さい値ならメッセージを表示
      if (this.rewriteStartHour > this.rewriteEndHour) {
        this.messageHourState = MSG_ERR_TIME_REVERCE;
        this.isHourState = false;
      } else if(this.rewriteStartHour == this.rewriteEndHour 
      && ((this.rewriteStartMin > this.rewriteEndMin) || (this.rewriteStartMin == this.rewriteEndMin))) {
        if (this.rewriteStartMin > this.rewriteEndMin) {
          // 入力された時間のToがFromよりも小さい値ならメッセージを表示
          this.messageHourState = MSG_ERR_TIME_REVERCE;
          this.isHourState = false;
        } else if (this.rewriteStartMin == this.rewriteEndMin) {
          console.log("start：" + this.rewriteStartHour + ":" + this.rewriteStartMin);
          console.log("end：" + this.rewriteEndHour + ":" + this.rewriteEndMin);
          // 入力された時間のFromとToが同じ値ならメッセージを表示
          this.messageHourState = MSG_ERR_TIME_SAME;
          this.isHourState = false;
        } else {
          this.isHourState = null;
        }
      } else {
        const [shiftStartHourStr, shiftStartMinStr] = this.shiftStart?.split(':');
        const [shiftEndHourStr, shiftEndMinStr] = this.shiftEnd?.split(':');
        const shiftStartHour = parseInt(shiftStartHourStr);
        const shiftStartMin = parseInt(shiftStartMinStr);
        const shiftEndHour = parseInt(shiftEndHourStr);
        const shiftEndMin = parseInt(shiftEndMinStr);
        // 区分が「早出」の時
        if (this.isEarlyStartCheck()) {
          // 入力された時間のFromがシフト開始よりも大きい値ならメッセージを表示
          if (this.rewriteStartHour > shiftStartHour) {
            this.messageHourState = MSG_ERR_EARLY_START;
            this.isHourState = false;
          } else if(this.rewriteStartHour == shiftStartHour) {
            if (this.rewriteStartMin >= shiftStartMin) {
              // 入力された時間のFromがシフト開始よりも大きい値ならメッセージを表示
              this.messageHourState = MSG_ERR_EARLY_START;
              this.isHourState = false;
            } else {
              this.isHourState = null;
            }
          } else {
            this.isHourState = null;
          }
        }
        // 区分が「残業」の時
        else if (this.isOvertimeCheck()) {
          // 入力された時間のToがシフト終了よりも小さい値ならメッセージを表示
          if (this.rewriteEndHour < shiftEndHour) {
            this.messageHourState = MSG_ERR_OVERWORK;
            this.isHourState = false;
          } else if(this.rewriteEndHour == shiftEndHour) {
            if (this.rewriteEndMin <= shiftEndMin) {
              // 入力された時間のToがシフト終了よりも小さい値ならメッセージを表示
              this.messageHourState = MSG_ERR_OVERWORK;
              this.isHourState = false;
            } else {
              this.isHourState = null;
            }
          } else {
            this.isHourState = null;
          }
        } else if (this.isLeaveCheck() || this.isLateCheck()) {
          // 区分が「×(遅刻)」または「★その他(早退)」の時
          if (this.rewriteStartHour < shiftStartHour) {
            // 入力された時間のFromがシフト開始よりも小さい値ならメッセージを表示
            this.messageHourState = MSG_ERR_SHIFT_START_BEFORE;
            this.isHourState = false;
          } else if (this.rewriteStartHour == shiftStartHour && this.rewriteStartMin < shiftStartMin) {
            // 入力された時間のFromがシフト開始よりも小さい値ならメッセージを表示
            this.messageHourState = MSG_ERR_SHIFT_START_BEFORE;
            this.isHourState = false;
          } else if (this.rewriteEndHour > shiftEndHour) {
            // 入力された時間のToがシフト終了よりも大きい値ならメッセージを表示
            this.messageHourState = MSG_ERR_SHIFT_END_AFTER;
            this.isHourState = false;
          } else if (this.rewriteEndHour == shiftEndHour && this.rewriteEndMin > shiftEndMin) {
            // 入力された時間のToがシフト終了よりも大きい値ならメッセージを表示
            this.messageHourState = MSG_ERR_SHIFT_END_AFTER;
            this.isHourState = false;
          } else {
            this.isHourState = null;
          }
        } else {
          this.isHourState = null;
        }
      }
      console.log("isHourState：" + this.isHourState);
      return this.isHourState;
    },
    constructionState: async function(){
      this.getConstructionValueFromAPI().then(()=>{
        return this.isConstructionState;
      })
    },
    // 工事入力内容変更時の動作
    changeConstructionCode: function(){
      this.getConstructionValueFromAPI();
    },
    // APIから工事コードにあった工事名を取得する
    getConstructionValueFromAPI: async function(){
      if(this.rewriteConstructionCode?.length > this.constructionCodeMaxLength){
        this.rewriteConstructionName = null;
        this.messageConstruction = "工事コードの文字数を" + this.constructionCodeMaxLength + "桁以内にしてください。";
        this.isConstructionState = false;
        return;
      }
      if(!this.isAllocationCalc || !this.isAttendanceCheck()){
        return;
      }
      if(this.rewriteConstructionCode == null || this.rewriteConstructionCode == ""){
                this.rewriteConstructionName = null;
                this.isConstructionState = false;
                this.messageConstruction = "工事コードを入力してください。";
                return;
      }
      console.log("rewriteConstructionCode：" + this.rewriteConstructionCode);
      let paramList = {
          shainCd: String(this.userId),
          constructionCd: this.rewriteConstructionCode
      };
      console.log("paramList：" + JSON.stringify(paramList));
      await this.getWithParams(config.URL.KOUJI_INFO, paramList)
          .then((response) => {
              console.debug("response：" + JSON.stringify(response));
              // レスポンスの結果がfalseならエラーメッセージを表示
              if(!response.result){
                this.showAlertError(config.MESSAGE.SERVER_ERROR);
                this.rewriteConstructionName = null;
                this.isConstructionState = false;
                return;
              }
              if(response.container == null){
                this.rewriteConstructionName = null;
                this.isConstructionState = false;
                const MSG_ERR_CONSTRUCTION_INVALID = "該当する工事コードが見つかりませんでした。";
                this.messageConstruction = MSG_ERR_CONSTRUCTION_INVALID;
              }
              else{
                this.setConstructionValue(response.container);
                this.isConstructionState = true;
              }
          })
          .catch((e) => {
              // Note: エラーメッセージは、共通処理で表示している
              console.error(e);
          })
          .finally(() => {
          });
    },
    // 工事検索ポップアップから帰ってきた値をセット
    setConstruction: function(value){
      this.rewriteConstructionCode = value.constructionCode;
      this.rewriteConstructionName = value.constructionName;
      this.isConstructionState = true;
    },
    setConstructionValue: function(items){
      this.rewriteConstructionName = items.name;
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if (text != null && text != "") {
        return false;
      } else {
        return true;
      }
    },

    // 変更検知メソッド
    chkChanged(){
      let isChange = false;
      if(this.originallyInfo.kbn !== this.rewriteApplicationKbn){
        console.debug("this.originallyInfo.kbn:" + this.originallyInfo.kbn);
        console.debug("this.rewriteApplicationKbn:" + this.rewriteApplicationKbn);
        isChange = true;
      }
      if(this.originallyInfo.date != this.rewriteApplicationDate){
        console.debug("this.originallyInfo.date:" + this.originallyInfo.date);
        console.debug("this.$rewriteApplicationDate:" + this.rewriteApplicationDate);
        isChange = true;
      }
      if(this.originallyInfo.startHour != this.rewriteStartHour){
        console.debug("this.originallyInfo.startHour:" + this.originallyInfo.startHour);
        console.debug("this.$rewriteStartHour:" + this.rewriteStartHour);
        isChange = true;
      }
      if(this.originallyInfo.startMin != this.rewriteStartMin){
        console.debug("this.originallyInfo.startMin:" + this.originallyInfo.startMin);
        console.debug("this.$rewriteStartMin:" + this.rewriteStartMin);
        isChange = true;
      }
      if(this.originallyInfo.endHour != this.rewriteEndHour){
        console.debug("this.originallyInfo.endHour:" + this.originallyInfo.endHour);
        console.debug("this.$rewriteEndHour:" + this.rewriteEndHour);
        isChange = true;
      }
      if(this.originallyInfo.endMin != this.rewriteEndMin){
        console.debug("this.originallyInfo.endMin:" + this.originallyInfo.endMin);
        console.debug("this.$rewriteEndMin:" + this.rewriteEndMin);
        isChange = true;
      }
      if(this.originallyInfo.disasterKbn != this.rewriteDisasterKbn){
        console.debug("this.originallyInfo.disasterKbn:" + this.originallyInfo.disasterKbn);
        console.debug("this.$rewriteDisasterKbn:" + this.rewriteDisasterKbn);
        isChange = true;
      }
      if(this.originallyInfo.reason != this.rewriteNote){
        if(!(this.rewriteNote == null && this.originallyInfo.reason == "" || this.rewriteNote == "" && this.originallyInfo.reason == null)){
          console.debug("this.originallyInfo.reason:" + this.originallyInfo.reason);
          console.debug("this.$rewriteNote:" + this.rewriteNote);
          isChange = true;
        }
      }
      if(this.originallyInfo.substituteWork != this.substituteWorkInfo.detailNo){
        console.debug("this.originallyInfo.substituteWork:" + this.originallyInfo.substituteWork);
        console.debug("this.substituteWorkInfo.detailNo:" + this.substituteWorkInfo.detailNo);
        isChange = true;
      }
      if(this.originallyInfo.substituteHoliday.date != this.substituteHolidayInfo.date 
      || this.originallyInfo.substituteHoliday.start != this.substituteHolidayInfo.start
      || this.originallyInfo.substituteHoliday.end != this.substituteHolidayInfo.end){
        console.debug("this.substituteHoliday.date:" + this.substituteHolidayInfo.date);
        console.debug("this.substituteHoliday.start:" + this.substituteHolidayInfo.start);
        console.debug("this.substituteHoliday.end:" + this.substituteHolidayInfo.end);
        console.debug("this.originallyInfo.substituteHoliday.date:" + this.originallyInfo.substituteHoliday.date);
        console.debug("this.originallyInfo.substituteHoliday.start:" + this.originallyInfo.substituteHoliday.start);
        console.debug("this.originallyInfo.substituteHoliday.end:" + this.originallyInfo.substituteHoliday.end);
        isChange = true;
      }
      if(this.originallyInfo.constructionCode != this.rewriteConstructionCode
        || this.originallyInfo.constructionName != this.rewriteConstructionName
      ){
        console.debug("this.originallyInfo.constructionCode:" + this.originallyInfo.constructionCode);
        console.debug("this.originallyInfo.constructionName:" + this.originallyInfo.constructionName);
        console.debug("this.rewriteConstructionCode:" + this.rewriteConstructionCode);
        console.debug("this.rewriteConstructionName:" + this.rewriteConstructionName);
        isChange = true;
      }
      console.debug("isChanged: " + isChange);
      this.isChanged = isChange;
    },

    // 承認区分が未承認かチェック
    // true: 承認済または否認済
    // false: 未承認
    isApproved: function(){
      if(this.approvalKbn == config.VALUE.APPROVAL_TYPE_APPROVAL || this.approvalKbn == config.VALUE.APPROVAL_TYPE_REJECTION){
        return true;
      } else {
        return false;
      }
    },
    isOnlyview:function(){
      // 承認画面から呼出した場合
      return this.clickType == 2;
    }
  },
  watch:{
    isChanged:{
      handler: function(newVal, oldVal) {
        console.debug("isChanged: " + newVal);
        if(newVal){
          // 再送信ボタン有効化
        }
      }
    },
    rewriteApplicationKbn:'chkChanged',
    rewriteApplicationDate:'chkChanged',
    rewriteStartHour:'chkChanged',
    rewriteStartMin:'chkChanged',
    rewriteEndHour:'chkChanged',
    rewriteEndMin:'chkChanged',
    rewriteDisasterKbn:'chkChanged',
    rewriteNote:'chkChanged',
    rewriteConstructionCode:'chkChanged',
    // rewriteConstructionName:'chkChanged',
    substituteWorkInfo:{
      handler: 'chkChanged',
      deep:true
    },
    substituteHolidayInfo:{
      handler: 'chkChanged',
      deep:true
    }
  }
};
</script>
<style>
.WorkM_ApplicationEditSummaryArea {
  background:rgb(238, 238, 238)!important;
  border-color: rgb(206, 212, 218) !important;
  padding: 0.3rem;
  width: 35%;
  height: auto;
}
.WorkM_InputGroup_ItemLabel {
  font-size: 0.85rem;
  color: rgb(13, 91, 136);
  font-weight: 700;
  margin: 0;
}
.WorkM_InputTimeGroup {
  display: flex;
}
.WorkM_InputTime_ApplicationEditModal .WorkM_InputTimeGroup_InputItem {
  width: 3.5rem;
}
.ApplicationEditModalHeaderVariant {
  /* background-color:rgb(128, 00, 128); */
  background-color:rgb(0, 128, 128);
}
.disabled {
  opacity: 0.5;
}

.text-black .form-control:disabled,.text-black .custom-select:disabled   {
  color: #495057;
  opacity: 1;
}
</style>
